import { UserResponse } from '@pb/mocks'

const setUnknownUserPropertiesUndefined = (user): any => {
  /*
    Some user properties come in as "UNKNOWN" instead of NULL. Normalize
    these properties until they are changed in a newer version of the user API.
  */
  return Object.entries(user).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value === 'UNKNOWN' ? undefined : value }),
    {},
  )
}

export const normalizeUserData = (user: UserResponse): any => {
  const { day, month, year, ...rest } = user

  return {
    ...setUnknownUserPropertiesUndefined(rest),
    birthDate: {
      day,
      month,
      year,
    },
  }
}

export default {
  normalizeUserData,
}
